export const UPDATE_SECTION = "UPDATE_SECTION";

export function update(object, key, attribute) {
    return {
        type: UPDATE_SECTION,
        payload: {object, key, attribute}
    };
}


// WEBPACK FOOTER //
// ./src/admin/components/editor/actions/update.js